<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        
        <Detail 
          :key="reloadDetails"
          :header="header" 
          :values="values" 
          @edit="edit" 
          :status="status"
        />
        <TabMenu :model="nestedRouteItems" />
        <router-view v-if="activity" :activity="activity" />
          
        <ActivityForm
          v-if="activityDialog"
          :activityForm="activityDialog"
          mode="auto"
          :activityToEdit="activity"
          :disabledArr="disabledArr"
          @close="activityDialog = false"
          @saved="savedActivity"
        />

      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";

import Detail from "@/mbp/universalComponents/Detail.vue";
import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'
import { kindOfRecord } from "@/mbp/activityKind";

export default {
  mixins: [BreadcrumbRecordMixin],
  components: {
    Detail,
    ActivityForm
  },
  data() {
    return {
      activityService: new ActivityService,
      nestedRouteItems: [
        {
          label: "Info",
          icon: 'pi pi-info-circle',
          to: `/activities/${this.$route.params.activityId}/detail`,
        },
        {
          label: "History",
          icon: 'pi pi-inbox',
          to: `/activities/${this.$route.params.activityId}/history`,
        },
      ],
      activity1: {},
      values: [],
      activityDialog: false,
      disabledArr: [],
      status: {},
      reloadDetails1: 0
    };
  },
  computed: {
    reloadDetails: {
      set() {
        this.reloadDetails1++
      },
      get() {
        return 'reloadDetails-' + this.reloadDetails1.toString()
      }
    },
    activity: {
      set(val) {
        if (val && val.activityId) {
          this.activity1 = val
          this.setActivityStatus()
        }
      },
      get() {
        return this.$store.getters['activities/getActivityForTabs'] && this.$store.getters['activities/getActivityForTabs'].activityId ? this.$store.getters['activities/getActivityForTabs'] : this.activity1
      }
    },
    breadcrumbRecordLabel() {
      return this.activity && this.activity.subject ? this.activity.subject : ''
    },
    // A task (kind TASK: Call, Email, Task) is labelled "Task" here and in its crumb; a
    // Meeting keeps "Activity". The route stays /activities/:id for both.
    isTask() {
      return !!(this.activity && this.activity.activityId) && kindOfRecord(this.activity) === 'TASK'
    },
    header() {
      return this.isTask ? "Task Details" : "Activity Details"
    },
    breadcrumbRecordType() {
      return this.isTask ? 'Task' : ''
    }
  },
  created() {
    
    // this.setValues()
    this.$store.dispatch('activities/setActivityForTabs', null )
    if (!(this.activity && this.activity.activityId)) {
      this.getActivity(this.$route.params.activityId)
    } else {
      this.reArrangeActivity()
      this.$store.dispatch('activities/setActivityForTabs', this.activity )
      this.setValues()
    }
    
    this.getActivityHistory(this.$route.params.activityId)
  },
  watch: {
    activity(val) {
      console.log('val is here', val)
      this.reArrangeActivity()
    }
  },
  methods: {
    reArrangeActivity() {
      let val = this.activity;


      if (this.activity.activityStatusId && !this.activity.activityStatus) {
        this.activity.activityStatus = {
          statusName: this.activity.activityStatusName,
          id: this.activity.activityStatusId
        }
      }

      if (this.activity.forUserId && !this.activity.user) {
        this.activity.user = {
          fullName: this.activity.forUser,
          id: this.activity.forUserId
        }
      }

      if (this.activity.activityTypeId && !this.activity.activityType) {
        this.activity.activityType = {
          activityTypeName: this.activity.activityTypeName,
          id: this.activity.activityTypeId
        }
      }

      if (this.activity.branchId && !this.activity.mbpBranch) {
        this.activity.mbpBranch = {
          branchName: this.activity.mbpBranchCode,
          id: this.activity.branchId
        }
      }

      if (this.activity.customerId && !this.activity.customer) {
        this.activity.customer = {
          custName: this.activity.custName,
          customerId: this.activity.customerId
        }
      }

      if (this.activity.contactId && !this.activity.contact) {
        this.activity.contact = {
          contactName: this.activity.contactName,
          contactId: this.activity.contactId
        }
      }

      if (this.activity.quoteVerId && !this.activity.quote) {
        this.activity.quote = {
          quoteVer: this.activity.quoteNo + '-' + this.activity.versionNo,
          quoteVerId: this.activity.quoteVerId,
          productValue: this.activity.productValue,
          quoteNo: this.activity.quoteNo,
          quoteStatus: this.activity.quoteStatus
        }
      }

      if (this.activity.meetingNotes && !this.activity.resultNotes) {
        this.activity.resultNotes = this.activity.meetingNotes
      }

      if (this.activity.activityResultId && !this.activity.activityResult) {
        this.activity.activityResult = {
          resultDesc: this.activity.activityResultDesc,
          id: this.activity.activityResultId
        }
      }

      if (this.activity.reminderFlag && !this.activity.reminder) {
        this.activity.reminder = this.activity.reminderFlag
      }

      if (this.activity.reminderTypeId && !this.activity.reminderType) {
        this.activity.reminderType = {
          reminderTypeName: this.activity.reminderTypeName,
          id: this.activity.reminderTypeId
        }
      }

      if (this.activity.createdById && !(val.createdBy && val.createdBy.createdById)) {
        this.activity.createdBy = {
          fullName: this.activity.createdBy,
          id: this.activity.createdById
        }
      }

      if (val.updatedById && !(val.updatedBy && val.updatedBy.updatedById)) {
        this.activity.updatedBy = {
          fullName: val.updatedBy,
          id: val.updatedById
        }
      }

      
      if (val && val.activityId) {
        this.$store.dispatch('activities/setActivityForTabs', val)
        this.setValues()
      }
    },
    setActivityStatus() {

      if (this.activity) {
        if (this.activity.activityStatus) {
          this.status = this.activity.activityStatus
          this.reloadDetails++

        } else if (this.activity.activityStatusId) {
          this.status = {
            id: this.activity.activityStatusId,
            statusName: this.activity.activityStatusName
          }
          this.reloadDetails++

        }
      }
    },
    setValues() {
      
      if (
        this.activity &&
        this.activity.activityStatus
      ) {
        this.setActivityStatus()

        this.values = [
          {
            title: this.isTask ? "Task Date:" : "Activity Date:",
            description: this.activity.dateCreated
          },
          {
            title: "Subject",
            description: this.activity.subject
          },
          {
            title: this.isTask ? "Type:" : "Activity Type:",
            description: this.activity.activityType.activityTypeName
          },
          null
        ]
      } else {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Activity not found.",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: `Activity not found.`
        })
      }
    },
    savedActivity(activity) {
      // this.activity = activity
      this.getActivity(this.$route.params.activityId)
      this.activityDialog = false
    },
    edit() {
      if (!(this.activity.activityStatus.statusName === 'Completed' || this.activity.activityStatus.statusName === 'Cancelled')) {
        this.activityDialog = true
      }
    },
    getActivity(activityId) {
      this.activityService
        .getActivity(activityId)
        .then(data => this.activity = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Activity",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: `Some data was not loaded from "activity"`
          })
        })
    },
    getActivityHistory(activityId) {
      this.activityService
        .getActivityHistory(activityId)
        .then(data => this.$store.dispatch('activities/setActivityHistoryForTab', data))
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Activity History",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: `Some data was not loaded from "recordHistoryActivity"`
          })
        })
    }
  }
}
</script>

<style>

</style>